/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import styles from './serviceProviderRegistration.module.scss';
import FormBox from '../common/FormBox/FormBox';
import { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { FaTrash } from 'react-icons/fa';
import languages from '../../data/selectInputOptions/languageList.json';
import BaseInput from 'components/common/BaseInput';
import UploadImage from 'views/ProviderProfile/components/UploadImage/UploadImage';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { EARLIEST_BEGIN_DATE } from '../../data/constants/constants';
import api from 'api';
import { useUser } from 'contexts/UserProvider';
import IconTooltipTextField from 'components/common/IconTooltipTextField';
import { ReactComponent as InfoIcon } from 'assets/icons/information.svg';
import * as S from '../forms/Forms.styled';
import ReactGA from 'react-ga4';
import { useProfilePicture, useUpdateProfilePicture } from 'hooks/useMyAccount';

const countries = ['', 'Australia', 'Canada'];

const LANGUAGES = Object.values(languages).map((item) => item.name);

interface Entry {
    license_number: string;
    country: string;
    date_issued: Date | null | string;
}

const initEntry: Entry = {
    license_number: '',
    country: '',
    date_issued: null,
};

interface Msg {
    license_number: string;
    country: string;
    date_issued: string;
}

const initMsg: Msg = {
    license_number: '',
    country: '',
    date_issued: '',
};

//new

interface Language {
    language: string | null;
    level: number | string;
}

const initLanguage: Language = {
    language: '',
    level: '',
};

interface LanguageMsg {
    language: string;
    level: string;
}

const initLanguageMsg: LanguageMsg = {
    language: '',
    level: '',
};

export default function ServiceProviderLanguage() {
    const licenseTableName = 'License';
    const languageTableName = 'Language';
    const [data, setData] = useState<Entry[]>([initEntry]);
    const [langData, setLangData] = useState<Language[]>([initLanguage]);
    const [validationMsg, setValidationMsg] = useState<Msg[]>([initMsg]);
    const [validationLng, setValidationLng] = useState<LanguageMsg[]>([initLanguageMsg]);
    const { user } = useUser();
    const name = user ? user.firstname + ' ' + user.lastname : 'User name';
    const { data: profilePictureUrl } = useProfilePicture();
    const updateProfilePicture = useUpdateProfilePicture();

    const loadData = (data: Entry[]) => {
        const tmp = new Array(data.length).fill(initMsg);
        setValidationMsg(tmp);
        setData(data);
    };
    const loadLanguage = (data: Language[]) => {
        const tmp = new Array(data.length).fill(initLanguageMsg);
        setValidationLng(tmp);
        setLangData(data);
    };

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: `${window.location.pathname}`,
            title: 'LicenseAndLanguage',
        });
    }, []);

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(loadData, licenseTableName);
        api.tableInput.newFetchCandidateInput(loadLanguage, languageTableName);
    }, []);

    // FIELD VALIDATION
    const validate = async (idx: number, field: string, value: string) => {
        let validated = true;

        const tmp = [...validationMsg];
        if (!field && !value) {
            for (let i = 0; i < data.length; i++) {
                for (const [key, value] of Object.entries(data[i])) {
                    let msg = '';
                    if (value === '') {
                        msg = 'Field should not be left empty';
                        validated = false;
                    }
                    if (key === 'date_issued' && value === null) {
                        const temp = [...data];
                        temp[idx] = {
                            ...data[idx],
                            date_issued: '',
                        };

                        setData(temp);
                    }
                    if (key === 'license_number') {
                        try {
                            await api.immigrationProfessional.checkLicense(value);
                        } catch {
                            msg = 'License already registered by another user';
                            validated = false;
                        }
                    }
                    tmp[i] = { ...tmp[i], [key]: msg };
                }
            }
        } else {
            let msg = '';
            if (value === '' || value === null) {
                msg = 'Field should not be left empty';
                validated = false;
            }
            tmp[idx] = { ...tmp[idx], [field]: msg };
        }
        setValidationMsg(tmp);

        const temp_languages = [...validationLng];
        if (!field && !value) {
            for (let i = 0; i < langData.length; i++) {
                // for (const [key, value] of Object.entries(langData[i])) {
                for (const key of Object.keys(initLanguage)) {
                    let msg = '';
                    const value = langData[i][key as keyof Language];
                    if (!value) {
                        msg = 'Field should not be left empty';
                        validated = false;
                    }
                    temp_languages[i] = { ...temp_languages[i], [key]: msg };
                }
            }
        } else {
            let msg = '';
            if (!value) {
                msg = 'Field should not be left empty';
                validated = false;
            }

            temp_languages[idx] = { ...temp_languages[idx], [field]: msg };
        }
        setValidationLng(temp_languages);

        return validated;
    };

    const handleUpdate = (idx: number, field: string, value: string) => {
        validate(idx, field, value);
        const temp = [...data];
        // if ( field === "date_issued"){

        //   temp[idx] = {...data[idx],
        //     [field]: value ? value.toLocaleDateString("en-US") : "",
        //   };

        // }else {}
        const tmpSelected = temp.map((item) => item.country);
        // Prevent duplicates
        if (field === 'country' && tmpSelected.includes(value)) return;
        temp[idx] = { ...data[idx], [field]: value };
        setData(temp);
    };

    const handleAddEntry = () => {
        if (data.length > 10) return;
        const newEntry: Entry = initEntry;

        const temp: Entry[] = [...data, newEntry];
        setData(temp);

        const tempMsg: Msg[] = [...validationMsg, initMsg];
        setValidationMsg(tempMsg);
    };

    const handleDeleteEntry = (idx: number) => {
        const temp: Entry[] = [...data];
        temp.splice(idx, 1);
        setData(temp);
        const tempMsg: Msg[] = [...validationMsg];
        tempMsg.splice(idx, 1);
        setValidationMsg(tempMsg);
    };

    const handleUpdateLanguages = (idx: number, field: string, value: string | number) => {
        validate(idx, field, String(value));
        const temp = [...langData];
        if (field === 'level') {
            temp[idx] = { ...langData[idx], [field]: Number(value) };
        }
        const tmpSelected = temp.map((item) => item.language);
        // Prevent language duplicates
        if (field === 'language' && tmpSelected.includes(String(value))) return;
        temp[idx] = { ...langData[idx], [field]: value };
        setLangData(temp);
    };

    const handleAddLanguages = () => {
        if (langData.length > 10) return;
        const newLanguage: Language = initLanguage;

        const temp: Language[] = [...langData, newLanguage];
        setLangData(temp);

        const tempMsg: LanguageMsg[] = [...validationLng, initLanguageMsg];
        setValidationLng(tempMsg);
    };

    const handleDeleteLanguages = (idx: number) => {
        const temp: Language[] = [...langData];
        temp.splice(idx, 1);
        setLangData(temp);
        const tempMsg: LanguageMsg[] = [...validationLng];
        tempMsg.splice(idx, 1);
        setValidationLng(tempMsg);
    };

    const handleLoadAvatar = (imgFile: File) => {
        updateProfilePicture.mutate(imgFile);
    };

    const handleDateUpdate = (idx: number, field: string, newDate: Date | null) => {
        validate(idx, field, String(newDate));
        const temp = [...data];
        temp[idx] = {
            ...data[idx],
            [field]: newDate ? newDate.toLocaleDateString('en-US') : '',
        };
        setData(temp);
    };

    return (
        <FormBox
            validation={validate}
            data={[data, langData]}
            tableNames={[licenseTableName, languageTableName]}
        >
            <S.Title>Consultant Info</S.Title>

            <div className={`flex items-center gap-x-2.5 mb-8 mt-8`}>
                <UploadImage src={profilePictureUrl || ''} getImageFile={handleLoadAvatar} />
                <div>
                    <p>{name}</p>
                    <p className={`${styles.boldPar}`}>Upload your profile picture</p>
                </div>
            </div>

            <h3 style={{ marginBottom: 25 }}>
                <span style={{ color: '#ff5252' }}>* </span>Countries Registered
            </h3>
            {data.map((_, i) => {
                return (
                    <div key={i}>
                        <div className="form-card-content-divider"></div>
                        <S.SubTitle>
                            <>License {i + 1}</>
                            <S.DeleteButton hidden={i === 0}>
                                <button
                                    onClick={() => {
                                        handleDeleteEntry(i);
                                    }}
                                >
                                    <FaTrash />
                                </button>
                            </S.DeleteButton>
                        </S.SubTitle>

                        <div>
                            <S.GridSection>
                                <S.FlexColumn>
                                    <Autocomplete
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                height: 30,
                                            },
                                        }}
                                        disablePortal
                                        id="country"
                                        value={data[i].country}
                                        options={countries}
                                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                                            validate(i, 'country', e.target.value);
                                        }}
                                        onChange={(_, v: any) => handleUpdate(i, 'country', v)}
                                        renderInput={(params) => (
                                            <BaseInput
                                                {...params}
                                                label="Country"
                                                error={validationMsg[i].country !== ''}
                                                helperText={validationMsg[i].country}
                                            />
                                        )}
                                    />
                                    {/* <span style={{ color: "red" }}>{validationMsg[i].license}</span> */}
                                </S.FlexColumn>
                                <S.FlexColumn>
                                    <BaseInput
                                        id="license"
                                        label="Consultant license number"
                                        type="text"
                                        value={data[i].license_number}
                                        error={Boolean(validationMsg[i].license_number)}
                                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                                            validate(i, 'license_number', e.target.value);
                                        }}
                                        onChange={(e) => {
                                            handleUpdate(i, 'license_number', e.target.value);
                                        }}
                                        helperText={validationMsg[i].license_number}
                                    />
                                    {/* <span style={{ color: "red" }}>{validationMsg[i].license}</span> */}
                                </S.FlexColumn>

                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        minDate={new Date(EARLIEST_BEGIN_DATE)}
                                        maxDate={new Date()}
                                        label="Date issued"
                                        inputFormat="dd/MM/yyyy"
                                        value={data[i].date_issued}
                                        onChange={(date: Date | null) => {
                                            handleDateUpdate(i, 'date_issued', date);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                error={validationMsg[i].date_issued !== ''}
                                                helperText={validationMsg[i].date_issued}
                                                inputProps={{
                                                    ...params.inputProps,
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </LocalizationProvider>
                            </S.GridSection>
                        </div>
                    </div>
                );
            })}
            <S.Footer>
                <S.FooterTitle>Add Country</S.FooterTitle>
                <div>
                    <S.FooterButton onClick={() => handleAddEntry()}>Add</S.FooterButton>
                </div>
            </S.Footer>

            {langData.map((_, i) => {
                return (
                    <div key={i}>
                        <div className="form-card-content-divider"></div>
                        <S.SubTitle>
                            <>Language {i + 1}</>
                            <S.DeleteButton hidden={i === 0}>
                                <button
                                    onClick={() => {
                                        handleDeleteLanguages(i);
                                    }}
                                >
                                    <FaTrash />
                                </button>
                            </S.DeleteButton>
                        </S.SubTitle>
                        <div>
                            {/* <div className="form-card-content-column"> */}
                            <S.GridSection>
                                <S.FlexColumn>
                                    <Autocomplete
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                height: 30,
                                            },
                                        }}
                                        disablePortal
                                        id="language"
                                        value={langData[i].language}
                                        options={LANGUAGES}
                                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                                            validate(i, 'language', e.target.value);
                                        }}
                                        onChange={(_, v: any) =>
                                            handleUpdateLanguages(i, 'language', v)
                                        }
                                        renderInput={(params) => (
                                            <BaseInput
                                                {...params}
                                                label="Service language"
                                                error={Boolean(validationLng[i].language)}
                                                helperText={validationLng[i].language}
                                            />
                                        )}
                                    />
                                    {/* <span style={{ color: "red" }}>{validationMsg[i].license}</span> */}
                                </S.FlexColumn>

                                <S.FlexColumn>
                                    <Autocomplete
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                height: 30,
                                            },
                                        }}
                                        disablePortal
                                        id="level"
                                        value={langData[i].level ? String(langData[i].level) : ''}
                                        options={['', '1', '2', '3', '4', '5']}
                                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                                            validate(i, 'level', e.target.value);
                                        }}
                                        onChange={(_, v: any) =>
                                            handleUpdateLanguages(i, 'level', Number(v))
                                        }
                                        renderInput={(params) => (
                                            <IconTooltipTextField
                                                {...params}
                                                label="Proficiency level"
                                                error={Boolean(validationLng[i].level)}
                                                helperText={validationLng[i].level}
                                                iconEnd={<InfoIcon />}
                                                endText={<ToolTip />}
                                            />
                                        )}
                                    />
                                </S.FlexColumn>
                            </S.GridSection>
                        </div>
                    </div>
                );
            })}
            <S.Footer>
                <S.FooterTitle>Add Language</S.FooterTitle>
                <div>
                    <S.FooterButton onClick={() => handleAddLanguages()}>Add</S.FooterButton>
                </div>
            </S.Footer>
        </FormBox>
    );
}

const ToolTip = () => {
    return (
        <>
            <b>
                <p className={styles.toolTipHeading}>Language proficiency categories</p>
            </b>
            <p className={styles.toolTipItem}>
                <b>1 </b>– Elementary proficiency
            </p>
            <p className={styles.toolTipItem}>
                <b> 2</b> – Limited working proficiency
            </p>
            <p className={styles.toolTipItem}>
                <b>3 </b>– Professional working proficiency
            </p>
            <p className={styles.toolTipItem}>
                <b>4 </b>– Full professional proficiency
            </p>
            <p className={styles.toolTipItem}>
                <b>5 </b>– Native / Bilingual Proficiency
            </p>
        </>
    );
};
